import { getAugmentedNamespace } from "./_commonjsHelpers.js";
import * as index from './../_node_modules/@amplitude/analytics-node/lib/esm/index.js';
const require$$0 = /* @__PURE__ */ getAugmentedNamespace(index);
export {
  require$$0 as default
};
//# sourceMappingURL=index4.js.map
